import * as React from "react";

const GraphicEqOff = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <rect
      x="1.41418"
      y="2"
      width="26.1034"
      height="2"
      transform="rotate(45 1.41418 2)"
      fill="currentColor"
    />
    <path
      d="M7 8.41421V18H9V10.4142L7 8.41421ZM11 12.4142V22H13V14.4142L11 12.4142ZM13 11.5858L11 9.58578V2H13V11.5858ZM15 16.4142V18H16.5858L15 16.4142ZM17 15.5858L15 13.5858V6H17V15.5858ZM9 7.58578L7.41422 6H9V7.58578ZM3 10V14H5V10H3ZM19 10V14H21V10H19Z"
      fill="currentColor"
    />
  </svg>
);

export default GraphicEqOff;
